export function fetchResources(apiUrl, accessToken, type) {
    return fetch(`${apiUrl}/v1/resources/${type}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function fetchDealerResourceCategories(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/resources/dealers/categories`, {
        headers: {
            "Authorization": `Bearer ${accessToken}`
        },
    });
}
export function fetchTmResourceCategories(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/resources/tm/categories`, {
        headers: {
            "Authorization": `Bearer ${accessToken}`
        },
    });
}
export function updateCategory(apiUrl, accessToken, categoryProps) {
    if (!categoryProps?.id)
        throw new Error('No category ID provided.');
    if (!categoryProps?.type)
        throw new Error('Please provide a category type.');
    const type = categoryProps.type.includes('dealer_access_categories') ? 'dealers' : 'tm';
    return fetch(`${apiUrl}/v1/resources/${type}/categories/${categoryProps.id}`, {
        method: 'PATCH',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": 'application/json',
        },
        body: JSON.stringify(categoryProps)
    });
}
export function createCategory(apiUrl, accessToken, categoryProps) {
    if (!categoryProps?.type)
        throw new Error('Please provide a category type.');
    const type = categoryProps.type.includes('dealer_access_categories') ? 'dealers' : 'tm';
    return fetch(`${apiUrl}/v1/resources/${type}/categories`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": 'application/json',
        },
        body: JSON.stringify(categoryProps)
    });
}
export function deleteCategory(apiUrl, accessToken, categoryProps) {
    if (!categoryProps?.type)
        throw new Error('Please provide a category type.');
    if (!categoryProps?.id)
        throw new Error('Please provide a category ID.');
    const type = categoryProps.type.includes('dealer_access_categories') ? 'dealers' : 'tm';
    return fetch(`${apiUrl}/v1/resources/${type}/categories/${categoryProps.id}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
}
